/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import { WorkflowNotificationVoModel } from './workflow-notification-vo.model';
import { WorkflowStepVoModel } from './workflow-step-vo.model';
import {WorkflowExternalDefDtoModel} from "./workflow-external-def-dto.model";
import {WorkflowExternalStepDefDtoModel} from "./workflow-external-step-def-dto.model";

export class WorkflowConfigDtoModel extends JSONable {
  workflowDefinitionUuid: string | null = null;
  workflowDefinitionName: string | null = null;
  workflowExternalDefDto: WorkflowExternalDefDtoModel | null = null;
  selectedSteps: WorkflowStepVoModel[] | null = null;
  selectedNotifications: WorkflowNotificationVoModel[] | null = null;
  workflowExternalStepDefDtos: WorkflowExternalStepDefDtoModel[] | null = null;
  label: string | null = null;
  description: string | null = null;

}
